import './styles/App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { NavBar } from "./components/NavBar";
import Landing from "./pages/Landing";
import { Projects } from "./pages/Projects";
import { Footer } from "./components/Footer";
import React, { useState, useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";

import { Asteroids } from "./projects/Asteroids";
import { ElementalBlitz } from "./projects/ElementalBlitz";
import { GDSTD1 } from "./projects/GDSTD1";
import { GDSTD2 } from "./projects/GDSTD2";
import { GDSTD3 } from "./projects/GDSTD3";
import { GDSTD4 } from "./projects/GDSTD4";
import { IzasSupermarket } from "./projects/IzasSupermarket";
import { MazeDiscover } from "./projects/MazeDiscover";
import { Nodebook } from "./projects/Nodebook";
import { PuzzleCave } from "./projects/PuzzleCave";
import { RomanceBrawl } from "./projects/RomanceBrawl";
import { Run01 } from "./projects/Run01";
import { ShepherdFarm } from "./projects/ShepherdFarm";
import { SpookyIsland } from "./projects/SpookyIsland";
import { StreetRacing } from "./projects/StreetRacing";
import { SUB } from "./projects/SUB";
import { WarehouseInvasion } from "./projects/WarehouseInvasion";

import { NotFound } from "./components/NotFound";
import About from "./pages/About";

import MainMenuBackgroundParticles from "./components/particles/Particles";
import { ProceduralStudy } from './projects/ProceduralStudy';
import Journey from './pages/Journey';
import { Contact } from './pages/Contact';

AOS.init({
  offset: 200,
  duration: 300,
  easing: 'ease-in-out-cubic',
  delay: 100,
  disable: 'mobile'
});

function App() {
  const [theme, setTheme] = useState(() => {
    return 'light';  // localStorage.getItem('theme') || 'light';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    // localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    const handleMouseClick = (event) => {
      if (event.button === 0) { // Left mouse button
        // setBgIndex((prevIndex) => (prevIndex + 1) % backgrounds.length);
      } else if (event.button === 2) { // Right mouse button
        // setAlphaIndex((prevIndex) => (prevIndex + 1) % alphas.length);
      }
    };

    window.addEventListener('mousedown', handleMouseClick);

    return () => {
      window.removeEventListener('mousedown', handleMouseClick);
    };
  }, []);

  return (
    <div className="Main">
      <Router>
        <NavBar theme={theme} toggleTheme={toggleTheme} />
        <div className="App">
          <TitleUpdater />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/projects" element={<Projects />} />

            <Route path="/projects/asteroids" element={<Asteroids />} />
            <Route path="/projects/elemental-blitz" element={<ElementalBlitz />} />
            <Route path="/projects/gdstd1" element={<GDSTD1 />} />
            <Route path="/projects/gdstd2" element={<GDSTD2 />} />
            <Route path="/projects/gdstd3" element={<GDSTD3 />} />
            <Route path="/projects/gdstd4" element={<GDSTD4 />} />
            <Route path="/projects/izas-supermarket" element={<IzasSupermarket />} />
            <Route path="/projects/maze-discover" element={<MazeDiscover />} />
            <Route path="/projects/nodebook" element={<Nodebook />} />
            <Route path="/projects/puzzle-cave" element={<PuzzleCave />} />
            <Route path="/projects/romance-brawl" element={<RomanceBrawl />} />
            <Route path="/projects/procedural-study" element={<ProceduralStudy />} />
            <Route path="/projects/run01" element={<Run01 />} />
            <Route path="/projects/shepherd-farm" element={<ShepherdFarm />} />
            <Route path="/projects/spooky-island" element={<SpookyIsland />} />
            <Route path="/projects/street-racing" element={<StreetRacing />} />
            <Route path="/projects/sub" element={<SUB />} />
            <Route path="/projects/warehouse-invasion" element={<WarehouseInvasion />} />

            <Route path="/about" element={<About />} />
            <Route path="/curriculum" element={<Journey />} />
            <Route path="/contact" element={<Contact />} />

            <Route path='*' element={<NotFound />} />
          </Routes>

          <Footer theme={theme} />
        </div>

        <MainMenuBackgroundParticles theme={theme} />

      </Router>
    </div>
  );
}

function TitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    let title = 'Lucas Coutinho | Game Programmer';

    if (path === '/about') {
      title = 'About me | Lucas Coutinho';
    } else if (path === '/curriculum') {
      title = 'Curriculum | Lucas Coutinho';
    } else if (path === '/contact') {
      title = 'Contact | Lucas Coutinho';
    } else if (path === '/projects/asteroids') {
      title = 'Asteroids | Lucas Coutinho';
    } else if (path === '/projects/elemental-blitz') {
      title = 'Elemental Blitz | Lucas Coutinho';
    } else if (path === '/projects/gdstd1') {
      title = 'GDSTD1 | Lucas Coutinho';
    } else if (path === '/projects/gdstd2') {
      title = 'GDSTD2 | Lucas Coutinho';
    } else if (path === '/projects/gdstd3') {
      title = 'GDSTD3 | Lucas Coutinho';
    } else if (path === '/projects/gdstd4') {
      title = 'GDSTD4 | Lucas Coutinho';
    } else if (path === '/projects/izas-supermarket') {
      title = 'Izas Supermarket | Lucas Coutinho';
    } else if (path === '/projects/maze-discover') {
      title = 'Maze Discover | Lucas Coutinho';
    } else if (path === '/projects/nodebook') {
      title = 'Nodebook | Lucas Coutinho';
    } else if (path === '/projects/puzzle-cave') {
      title = 'Puzzle Cave | Lucas Coutinho';
    } else if (path === '/projects/romance-brawl') {
      title = 'Romance Brawl | Lucas Coutinho';
    } else if (path === '/projects/procedural-study') {
      title = 'Procedural Study | Lucas Coutinho';
    } else if (path === '/projects/run01') {
      title = 'Run01 | Lucas Coutinho';
    } else if (path === '/projects/shepherd-farm') {
      title = 'Shepherd Farm | Lucas Coutinho';
    } else if (path === '/projects/spooky-island') {
      title = 'Spooky Island | Lucas Coutinho';
    } else if (path === '/projects/street-racing') {
      title = 'Street Racing | Lucas Coutinho';
    } else if (path === '/projects/sub') {
      title = 'SUB | Lucas Coutinho';
    } else if (path === '/projects/warehouse-invasion') {
      title = 'Warehouse Invasion | Lucas Coutinho';
    } else if (path !== '/' && !path.startsWith('/projects')) {
      title = 'Page Not Found | Lucas Coutinho';
    }

    document.title = title;
  }, [location]);

  return null;
}

export default App;
